export const question = [
    {
      id: 1,
      question: "Overview",
      answer: [
        {
          item: "We have a robust Dealing Room with seasoned Forex Dealers who can buy and sell FCY Funds of the customer at competitive rates. We also book Forward Contracts and Swaps for select top customers, who are willing to hedge their Exchange Risks.",
        },
      ],
    },
    {
      id: 2,
      question: "Deposit",
      answer: [
        {
          title: "Savings",
        },
        {
          item: "Savings Accounts can be opened for individuals in US Dollar/Pound Sterling/ South African Rand/Euro. Cheque book facility is an option available. With this product, we also offer a contactless lndo Visa Debit Card facility, which is ideal for businessmen /employees travelling frequently outside Zambia, who can draw money from any of the VISA enable ATMs around the world.",
        },
        {
          title: "Current Account",
        },
        {
          item: "Current Account can be opened for business houses and also for individuals in US Dollar/ Pound Sterling/South African Rand/Euro. Cheque book facility is available. Payments within Zambia.",
        }
      ],
    },
    {
      id: 3,
      question: "Services",
      answer: [
        {
          title: "Dealing Room Operations",
        },
        {
          item: "We have a robust Dealing Room with seasoned Forex Dealers who can buy and sell FCY Funds of the customer at competitive rates. We also book Forward Contracts; Option Contracts and Swaps for select top customers, who are willing to hedge their Exchange Risks. can be made by way of FCY Cheques, and the clearing of cheques are done at free of cost. With this product, we also offer a contactless lndo Visa Debit Card facility, which is ideal for businessmen/ employees travelling frequently outside Zambia, who can draw money from any of the VISA enabled ATMs around the world.",
        },
        {
          title: "Fixed Deposits",
        },
        {
          item: "We offer attractive interest rates comparable to international market on Fixed Deposits opened in US Dollar/ Pound Sterling/ZAR Rand/EU Euro. This product is deal for individuals and for the business houses who have excess liquidity for a short period.",
        },
        {
          title: "Fixed DeInternational Remittances Facilities through Swift in Various Currencies posits",
        },
        {
          item: "We offer international remittances facilities in various foreign currencies such as Indian Rupee, US Dollar, Pound Sterling, EU Euro and ZAR etc",
        },
      ],
    },
    {
      id: 4,
      question: "Other Services",
      answer: [
        {
          title: "Special Remittances Facility Rupee Transfers to India:",
        },
        {
          item: "We offer fast & cheap remittances in Rupees to India, even to non-customers",
        },
        {
          title: "Handling Exports/Imports:",
        },
        {
          item: "We handle inward and Outward Bills on collection basis. We negotiate and deal in FCY Import/Export document under Letter of Credit",
        },
        {
          title: "Issuance of FCY Letters of Credit and Foreign Currency Guarantees:",
        },
        {
          item: "We issue Letters of Credit and Guarantees denominated in Foreign Currencies as well as establishing standby Letters of Credit to facilitate international trade",
        },
        {
          title: "Collection of Clean FCY Bills/Cheques:",
        },
        {
          item: "We clear foreign currency denominated cheques and clean bills within and/or outside Zambia",
        },
      ],
    },
   
  ];